// src/components/Sidebar.jsx
import React from "react";
import { Link, useLocation } from "react-router-dom";
import "./Sidebar.css";
import logo from "../assets/Logo_Small.png";
import SidebarAccordion from "./SidebarAccordion";

function Sidebar() {
  const location = useLocation();
  const currentPath = location.pathname + location.search;
  console.log(currentPath);
  const opportunityLinks = [
    { label: "DH2 BAD-1", path: "/map?opportunity=dh2-bad-1" },
    { label: "DH2 SOR-1", path: "/map?opportunity=dh2-sor-1" },
    { label: "DH2 Lorca", path: "/map?opportunity=dh2-lorca" },
    { label: "H2B2 Coreses", path: "/map?opportunity=h2b2-coreses" },
    { label: "ANSASOL", path: "/map?opportunity=ansasol" },
    { label: "Avalon Renovables PBAC", path: "/map?opportunity=avalon-renovables-pbac" },
  ];
  const costEstimationLinks = [
    { label: "Crossings", path: "/crossings" },
    { label: "Facilities", path: "/facilities" },
    { label: "Fittings", path: "/fittings" },
    { label: "Land Use", path: "/landuse" },
  ];

  return (
    <div className="sidebar">
      {/* Logo Row */}
      <div className="sidebar-logo-row">
        <Link to="/">
          <img src={logo} alt="Logo" className="logo-img" />
        </Link>
      </div>

      {/* Navigation */}
      <nav>
        <ul>
          <li className={currentPath === "/" ? "selected" : ""}>
            <Link to="/"> Home</Link>
          </li>
          <SidebarAccordion
            title="Opportunities"
            links={opportunityLinks}
            currentPath={currentPath}
          />
          {/*
          <SidebarAccordion
            title="Cost Estimation"
            links={costEstimationLinks}
            currentPath={currentPath}
          />
          */}
          <li className={currentPath === "/map" ? "selected" : ""}>
            <Link to="/map"> Map</Link>
          </li>
          <li className={currentPath === "/map-full" ? "selected" : ""}>
            <Link to="/map-full"> Map Fullscreen</Link>
          </li>
        </ul>
      </nav>
    </div>
  );
}

export default Sidebar;
